import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    private checkInterval = 60000; // Check every 60 seconds

    private baseUrl: string = environment.baseUrl;
    private baseanotherUrl: string = environment.baseUrlOther;

    constructor(
        private router: Router,
        private http: HttpClient,
        private readonly keycloakService: KeycloakService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { this.startSessionCheck(); }

    private startSessionCheck(): void {
        setInterval(() => {
            console.log('checking if user is still logged in');
            if (!this.keycloakService.isLoggedIn()) {
                this.keycloakService.login();
            }
        }, this.checkInterval);
    }

    redirectToLoginPage(): Promise<void> {
        if (isPlatformBrowser(this.platformId)) {
            return this.keycloakService.login();
        } else {
            console.warn('Login called on server');
            return Promise.resolve();
        }
    }

    redirectToSignupPage(): Promise<void> {
        if (isPlatformBrowser(this.platformId)) {
            return this.keycloakService.register();
        } else {
            console.warn('Signup called on server');
            return Promise.resolve();
        }
    }
    
    
    gettUserName(): string {
        if (isPlatformBrowser(this.platformId)) {
            return this.keycloakService.getUsername();
        }
        return 'Unavailable';
    }

    get userName(): string {
        if (isPlatformBrowser(this.platformId)) {
            return this.keycloakService.getUsername();
        }
        return 'Unavailable';
    }

    isLoggedIn(): boolean {
        if (isPlatformBrowser(this.platformId)) {
            return this.keycloakService.isLoggedIn();
        }
        return false;
    }

    logout(): void {
        if (isPlatformBrowser(this.platformId)) {
            console.log('logging out..');
            this.getToken().then(token => {

                const headers = {
                    Authorization: 'Bearer ' + token
                };
                this.http
                    .post(
                        `${this.baseanotherUrl}/logout`,
                        {},
                        { headers: headers }
                    )
                    .pipe(
                        map((res) => {
                            localStorage.removeItem('token');
                            this.keycloakService.logout(environment.keycloak.postLogoutRedirectLogoutUri);

                        })
                    )
                    .subscribe();
            });
        } else {
            console.warn('Logout called on server');
        }
    }

    async getToken() {
        if (isPlatformBrowser(this.platformId)) {
            let token = localStorage.getItem('accessToken');
            const refreshToken = localStorage.getItem('refreshToken');
            
            console.log("token is "+token+" -- ");

            if (token && this.isTokenValid(token, 30)) {
                console.log("returning existing token");
                return token;
            }

            if (refreshToken) {
                const newToken = await this.refreshToken(refreshToken);
                if (newToken) {
                    localStorage.setItem('accessToken', newToken);
                    return newToken;
                }
            }

            try {
                token = await this.keycloakService.getToken();
                console.log("cannot find in storage. getting new token ", token);
                if (token) {
                    localStorage.setItem('accessToken', token);
                    return token;
                }
            } catch (error) {
                console.error('Error requesting new token from Keycloak:', error);
                throw new Error('Unable to retrieve or refresh token');
            }
        }
        return Promise.reject('Token request on server');
    }


    isTokenValid(token: string, minValidityInSeconds: number) : boolean {
        const tokenParsed = this.parseJwt(token);
        const expiresIn = tokenParsed.exp ? tokenParsed.exp - (Date.now() / 1000) : 0;
        console.log('exp: '+expiresIn+' -- '+minValidityInSeconds);
        return expiresIn > minValidityInSeconds;
    }


    async refreshToken(refreshToken: string) {
        try {
            const response = await fetch(environment.keycloak.refreshAuthority, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    'grant_type': 'refresh_token',
                    'refresh_token': refreshToken,
                    'client_id': environment.keycloak.clientId,
                    //'client_secret': '{client_secret}' // if required
                })
            });

            if (response.ok) {
                console.log("refresh worked and got a new access token!")
                const data = await response.json();
                localStorage.setItem('accessToken', data.access_token);
                localStorage.setItem('refreshToken', data.refresh_token);
                return data.access_token;
            } else {
                throw new Error('Token refresh failed');
            }
        } catch (error) {
            console.error('Error during token refresh', error);
            return null;
        }
    }



    getUserProfile() {
        if (isPlatformBrowser(this.platformId)) {
            return this.keycloakService.loadUserProfile();
        }
        return Promise.reject('Profile request on server');
    }

    getNotifications(displayAll: boolean, token: any): Observable<any> {
        const headers = {
            "Authorization": "Bearer " + token
        }

        let url = `${this.baseanotherUrl}/notification`;
        if (displayAll) {
            url += '?displayAll=true';

        }

        return this.http.get(url, { headers: headers });
    }

    parseJwt(token: string) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }
}
